import { IOffer } from '../../../../types/offer';
import { getUtilitiesTermsPrice } from './getUtilitiesTermsPrice';
import { getDepositPrice } from './getDepositPrice';
import { getFeePrice } from './getFeePrice';
import { getAgentBonusPrice } from '../getAgentBonusPrice';
import { getLeasePeriod } from './getLeasePeriod';

export function getRentPriceInfo(
  offer: IOffer,
  isAgent: boolean,
  isCianDealRentExperiment: boolean,
): string | undefined {
  const infoParts = [
    getLeasePeriod(offer),
    getUtilitiesTermsPrice(offer),
    getFeePrice(offer, isAgent, isCianDealRentExperiment),
    getDepositPrice(offer),
    getAgentBonusPrice(offer, isAgent),
  ].filter(Boolean);

  if (infoParts.length > 0) {
    const res = infoParts.join(', ');

    return `${res[0].toUpperCase()}${res.slice(1)}`;
  }

  return undefined;
}
